var map = {
	"./accessibility-outline.svg": "b287",
	"./accessibility-sharp.svg": "5803",
	"./accessibility.svg": "b741",
	"./add-circle-outline.svg": "1fee",
	"./add-circle-sharp.svg": "16c9",
	"./add-circle.svg": "876a",
	"./add-outline.svg": "8a76",
	"./add-sharp.svg": "70bf",
	"./add.svg": "c2a3",
	"./airplane-outline.svg": "8512",
	"./airplane-sharp.svg": "3e3e",
	"./airplane.svg": "ba08",
	"./alarm-outline.svg": "33f5",
	"./alarm-sharp.svg": "ae8d",
	"./alarm.svg": "3c85",
	"./albums-outline.svg": "c45f",
	"./albums-sharp.svg": "0b29",
	"./albums.svg": "b8c8",
	"./alert-circle-outline.svg": "e18c",
	"./alert-circle-sharp.svg": "d6bb",
	"./alert-circle.svg": "6f33",
	"./alert-outline.svg": "a326",
	"./alert-sharp.svg": "4746",
	"./alert.svg": "f2db",
	"./ali-loading.svg": "b416",
	"./american-football-outline.svg": "7a04",
	"./american-football-sharp.svg": "0b64",
	"./american-football.svg": "57b2",
	"./analytics-outline.svg": "9bfe",
	"./analytics-sharp.svg": "90ea7",
	"./analytics.svg": "ad7f",
	"./aperture-outline.svg": "5762",
	"./aperture-sharp.svg": "075c",
	"./aperture.svg": "cace",
	"./apps-outline.svg": "a029",
	"./apps-sharp.svg": "210b",
	"./apps.svg": "dda1",
	"./archive-outline.svg": "4d45",
	"./archive-sharp.svg": "4f75",
	"./archive.svg": "9ce5",
	"./arrow-back-circle-outline.svg": "d71b",
	"./arrow-back-circle-sharp.svg": "ca75",
	"./arrow-back-circle.svg": "e780",
	"./arrow-back-outline.svg": "1edb",
	"./arrow-back-sharp.svg": "acf2",
	"./arrow-back.svg": "27dc",
	"./arrow-down-circle-outline.svg": "7ab7",
	"./arrow-down-circle-sharp.svg": "dda2",
	"./arrow-down-circle.svg": "48da",
	"./arrow-down-outline.svg": "9c1c",
	"./arrow-down-sharp.svg": "18be",
	"./arrow-down.svg": "1033",
	"./arrow-forward-circle-outline.svg": "f681",
	"./arrow-forward-circle-sharp.svg": "257c",
	"./arrow-forward-circle.svg": "41a0",
	"./arrow-forward-outline.svg": "a230",
	"./arrow-forward-sharp.svg": "ed51",
	"./arrow-forward.svg": "7385",
	"./arrow-redo-circle-outline.svg": "94cd",
	"./arrow-redo-circle-sharp.svg": "9afa",
	"./arrow-redo-circle.svg": "c854",
	"./arrow-redo-outline.svg": "dce5",
	"./arrow-redo-sharp.svg": "1086",
	"./arrow-redo.svg": "4f915",
	"./arrow-undo-circle-outline.svg": "39e9",
	"./arrow-undo-circle-sharp.svg": "a224",
	"./arrow-undo-circle.svg": "bcfd",
	"./arrow-undo-outline.svg": "7dba",
	"./arrow-undo-sharp.svg": "f605",
	"./arrow-undo.svg": "0373",
	"./arrow-up-circle-outline.svg": "163c",
	"./arrow-up-circle-sharp.svg": "239a",
	"./arrow-up-circle.svg": "1805",
	"./arrow-up-outline.svg": "4e82",
	"./arrow-up-sharp.svg": "479b",
	"./arrow-up.svg": "cd54",
	"./at-circle-outline.svg": "f860",
	"./at-circle-sharp.svg": "8af5",
	"./at-circle.svg": "b0e4",
	"./at-outline.svg": "2a0b",
	"./at-sharp.svg": "b341",
	"./at.svg": "152c",
	"./attach-outline.svg": "6129",
	"./attach-sharp.svg": "fe3f",
	"./attach.svg": "cc6f",
	"./auto-ind.svg": "fbb8",
	"./backspace-outline.svg": "7b7f",
	"./backspace-sharp.svg": "fc4e",
	"./backspace.svg": "0aa9",
	"./bag-add-outline.svg": "8f5e",
	"./bag-add-sharp.svg": "8ad9",
	"./bag-add.svg": "7b8c",
	"./bag-check-outline.svg": "72e1",
	"./bag-check-sharp.svg": "0331",
	"./bag-check.svg": "a275",
	"./bag-handle-outline.svg": "a052",
	"./bag-handle-sharp.svg": "184b",
	"./bag-handle.svg": "5f17",
	"./bag-outline.svg": "a725",
	"./bag-remove-outline.svg": "9127",
	"./bag-remove-sharp.svg": "2b77",
	"./bag-remove.svg": "f9065",
	"./bag-sharp.svg": "7b9c",
	"./bag.svg": "c327",
	"./balloon-outline.svg": "6f20",
	"./balloon-sharp.svg": "7c7b",
	"./balloon.svg": "f207",
	"./ban-outline.svg": "b00f",
	"./ban-sharp.svg": "0627",
	"./ban.svg": "242f",
	"./bandage-outline.svg": "067c",
	"./bandage-sharp.svg": "b599",
	"./bandage.svg": "4c9f",
	"./bar-chart-outline.svg": "df32",
	"./bar-chart-sharp.svg": "0481",
	"./bar-chart.svg": "674e",
	"./barbell-outline.svg": "ab50",
	"./barbell-sharp.svg": "f81b",
	"./barbell.svg": "deed",
	"./barcode-outline.svg": "cc8d",
	"./barcode-sharp.svg": "5643",
	"./barcode.svg": "f5ac",
	"./baseball-outline.svg": "7837",
	"./baseball-sharp.svg": "4c5b",
	"./baseball.svg": "8646",
	"./basket-outline.svg": "be8f",
	"./basket-sharp.svg": "3607",
	"./basket.svg": "cb53",
	"./basketball-outline.svg": "9c70",
	"./basketball-sharp.svg": "285b",
	"./basketball.svg": "683c",
	"./battery-charging-outline.svg": "49e7",
	"./battery-charging-sharp.svg": "624b",
	"./battery-charging.svg": "55d3",
	"./battery-dead-outline.svg": "1631",
	"./battery-dead-sharp.svg": "19b2",
	"./battery-dead.svg": "28a6",
	"./battery-full-outline.svg": "5dba",
	"./battery-full-sharp.svg": "470e",
	"./battery-full.svg": "94a5",
	"./battery-half-outline.svg": "7166",
	"./battery-half-sharp.svg": "e48a",
	"./battery-half.svg": "2fbf",
	"./beaker-outline.svg": "004a",
	"./beaker-sharp.svg": "b1b6",
	"./beaker.svg": "bc3e",
	"./bed-outline.svg": "c803",
	"./bed-sharp.svg": "c922",
	"./bed.svg": "2fb5",
	"./beer-outline.svg": "150c",
	"./beer-sharp.svg": "4abe",
	"./beer.svg": "62c0",
	"./bicycle-outline.svg": "b5a9",
	"./bicycle-sharp.svg": "72b4",
	"./bicycle.svg": "ae5e",
	"./bluetooth-outline.svg": "77ce",
	"./bluetooth-sharp.svg": "c406",
	"./bluetooth.svg": "8eb3",
	"./boat-outline.svg": "5c68",
	"./boat-sharp.svg": "4c74",
	"./boat.svg": "5017",
	"./body-outline.svg": "4c71",
	"./body-sharp.svg": "abd3",
	"./body.svg": "813d",
	"./bonfire-outline.svg": "b579",
	"./bonfire-sharp.svg": "ab9d",
	"./bonfire.svg": "0227",
	"./book-outline.svg": "c94b",
	"./book-sharp.svg": "6a1d",
	"./book.svg": "6ac0",
	"./bookmark-outline.svg": "a8c7",
	"./bookmark-sharp.svg": "756b",
	"./bookmark.svg": "c819",
	"./bookmarks-outline.svg": "b952",
	"./bookmarks-sharp.svg": "295d",
	"./bookmarks.svg": "a7e6",
	"./bowling-ball-outline.svg": "a160",
	"./bowling-ball-sharp.svg": "cb44",
	"./bowling-ball.svg": "4450",
	"./briefcase-outline.svg": "8fd9",
	"./briefcase-sharp.svg": "e839",
	"./briefcase.svg": "e2f9",
	"./browsers-outline.svg": "0f3c",
	"./browsers-sharp.svg": "61fc",
	"./browsers.svg": "694f",
	"./brush-outline.svg": "1ec7",
	"./brush-sharp.svg": "5869",
	"./brush.svg": "7db2",
	"./bug-outline.svg": "3a62",
	"./bug-sharp.svg": "9cfb",
	"./bug.svg": "1779",
	"./build-outline.svg": "4534",
	"./build-sharp.svg": "4e47",
	"./build.svg": "84c3",
	"./bulb-outline.svg": "0195",
	"./bulb-sharp.svg": "1bae",
	"./bulb.svg": "5a37",
	"./bus-outline.svg": "8e97",
	"./bus-sharp.svg": "e62c",
	"./bus.svg": "8f17",
	"./business-outline.svg": "d8b6",
	"./business-sharp.svg": "852c",
	"./business.svg": "c1db",
	"./cabinet.svg": "6cc8",
	"./cafe-outline.svg": "ccac",
	"./cafe-sharp.svg": "4599",
	"./cafe.svg": "ce4f",
	"./calculator-outline.svg": "424a",
	"./calculator-sharp.svg": "d724",
	"./calculator.svg": "879a",
	"./calendar-clear-outline.svg": "9f51",
	"./calendar-clear-sharp.svg": "3b3f",
	"./calendar-clear.svg": "8267",
	"./calendar-number-outline.svg": "958a",
	"./calendar-number-sharp.svg": "c6a6",
	"./calendar-number.svg": "010a",
	"./calendar-outline.svg": "85ff",
	"./calendar-sharp.svg": "2858",
	"./calendar.svg": "0870",
	"./call-outline.svg": "e943",
	"./call-sharp.svg": "9de1",
	"./call.svg": "cf76",
	"./camera-outline.svg": "de69",
	"./camera-reverse-outline.svg": "be21",
	"./camera-reverse-sharp.svg": "2519",
	"./camera-reverse.svg": "1973",
	"./camera-sharp.svg": "39b0",
	"./camera.svg": "8ce0",
	"./car-outline.svg": "1fab",
	"./car-sharp.svg": "449e",
	"./car-sport-outline.svg": "e4d4",
	"./car-sport-sharp.svg": "4c95",
	"./car-sport.svg": "5d71",
	"./car.svg": "ec2f",
	"./card-outline.svg": "bf06",
	"./card-sharp.svg": "c74e",
	"./card.svg": "2d9e",
	"./caret-back-circle-outline.svg": "9895",
	"./caret-back-circle-sharp.svg": "4d06",
	"./caret-back-circle.svg": "29af",
	"./caret-back-outline.svg": "cdfe",
	"./caret-back-sharp.svg": "a86b",
	"./caret-back.svg": "22a7",
	"./caret-down-circle-outline.svg": "28ca",
	"./caret-down-circle-sharp.svg": "0efa",
	"./caret-down-circle.svg": "cb6e",
	"./caret-down-outline.svg": "49ac",
	"./caret-down-sharp.svg": "4837",
	"./caret-down.svg": "028e",
	"./caret-forward-circle-outline.svg": "8872",
	"./caret-forward-circle-sharp.svg": "2634",
	"./caret-forward-circle.svg": "71c7",
	"./caret-forward-outline.svg": "26de",
	"./caret-forward-sharp.svg": "e00a",
	"./caret-forward.svg": "d7c4",
	"./caret-up-circle-outline.svg": "4ef3",
	"./caret-up-circle-sharp.svg": "dccd",
	"./caret-up-circle.svg": "e607",
	"./caret-up-outline.svg": "0174",
	"./caret-up-sharp.svg": "b06e",
	"./caret-up.svg": "a5f2",
	"./cart-outline.svg": "f56c",
	"./cart-sharp.svg": "7fb2",
	"./cart.svg": "908e",
	"./cash-outline.svg": "a26f",
	"./cash-sharp.svg": "5c59",
	"./cash.svg": "c489",
	"./cellular-outline.svg": "db08",
	"./cellular-sharp.svg": "b36e",
	"./cellular.svg": "fab4",
	"./chatbox-ellipses-outline.svg": "51b8",
	"./chatbox-ellipses-sharp.svg": "98b3",
	"./chatbox-ellipses.svg": "ab2c",
	"./chatbox-outline.svg": "0716",
	"./chatbox-sharp.svg": "6ee8",
	"./chatbox.svg": "e4e4",
	"./chatbubble-ellipses-outline.svg": "13aa",
	"./chatbubble-ellipses-sharp.svg": "0671",
	"./chatbubble-ellipses.svg": "aa1d",
	"./chatbubble-outline.svg": "0533",
	"./chatbubble-sharp.svg": "f5b0",
	"./chatbubble.svg": "26c5",
	"./chatbubbles-outline.svg": "7fd7",
	"./chatbubbles-sharp.svg": "cb14",
	"./chatbubbles.svg": "6605d",
	"./check.svg": "f75a",
	"./checkbox-outline.svg": "e96f",
	"./checkbox-sharp.svg": "143b",
	"./checkbox.svg": "8963",
	"./checkmark-circle-outline.svg": "c4f8",
	"./checkmark-circle-sharp.svg": "514d",
	"./checkmark-circle.svg": "03be",
	"./checkmark-done-circle-outline.svg": "7b28",
	"./checkmark-done-circle-sharp.svg": "943a",
	"./checkmark-done-circle.svg": "95dd",
	"./checkmark-done-outline.svg": "f7d4",
	"./checkmark-done-sharp.svg": "ffcf",
	"./checkmark-done.svg": "b527",
	"./checkmark-outline.svg": "9f71",
	"./checkmark-sharp.svg": "61bf",
	"./checkmark.svg": "2703",
	"./chevron-back-circle-outline.svg": "056b",
	"./chevron-back-circle-sharp.svg": "b29c",
	"./chevron-back-circle.svg": "18ab",
	"./chevron-back-outline.svg": "1b6b",
	"./chevron-back-sharp.svg": "f98c",
	"./chevron-back.svg": "fe52",
	"./chevron-down-circle-outline.svg": "8cb1",
	"./chevron-down-circle-sharp.svg": "4a5e",
	"./chevron-down-circle.svg": "8ce8",
	"./chevron-down-outline.svg": "62be",
	"./chevron-down-sharp.svg": "6a5e",
	"./chevron-down.svg": "02aa",
	"./chevron-forward-circle-outline.svg": "a48d",
	"./chevron-forward-circle-sharp.svg": "993d",
	"./chevron-forward-circle.svg": "0b35",
	"./chevron-forward-outline.svg": "d973",
	"./chevron-forward-sharp.svg": "cc86",
	"./chevron-forward.svg": "cdb1",
	"./chevron-up-circle-outline.svg": "ab14",
	"./chevron-up-circle-sharp.svg": "8635",
	"./chevron-up-circle.svg": "eaae",
	"./chevron-up-outline.svg": "d6b9",
	"./chevron-up-sharp.svg": "9f32",
	"./chevron-up.svg": "5583",
	"./clipboard-outline.svg": "d3d0",
	"./clipboard-sharp.svg": "45a2",
	"./clipboard.svg": "bc35",
	"./close-circle-outline.svg": "3eaf",
	"./close-circle-sharp.svg": "8746",
	"./close-circle.svg": "1dbe",
	"./close-outline.svg": "3594",
	"./close-sharp.svg": "7d2f",
	"./close.svg": "7710",
	"./cloud-circle-outline.svg": "318d",
	"./cloud-circle-sharp.svg": "7f18",
	"./cloud-circle.svg": "1325",
	"./cloud-done-outline.svg": "93b25",
	"./cloud-done-sharp.svg": "0e36",
	"./cloud-done.svg": "557c",
	"./cloud-download-outline.svg": "3dc2",
	"./cloud-download-sharp.svg": "67b1",
	"./cloud-download.svg": "28aa",
	"./cloud-offline-outline.svg": "a935",
	"./cloud-offline-sharp.svg": "39c9",
	"./cloud-offline.svg": "0f13",
	"./cloud-outline.svg": "65f4",
	"./cloud-sharp.svg": "60dd",
	"./cloud-upload-outline.svg": "c103",
	"./cloud-upload-sharp.svg": "62ea",
	"./cloud-upload.svg": "8674",
	"./cloud.svg": "61e1",
	"./cloudy-night-outline.svg": "349e",
	"./cloudy-night-sharp.svg": "e071",
	"./cloudy-night.svg": "c04d",
	"./cloudy-outline.svg": "058f",
	"./cloudy-sharp.svg": "5689",
	"./cloudy.svg": "df7a",
	"./code-download-outline.svg": "1887",
	"./code-download-sharp.svg": "00d9",
	"./code-download.svg": "68f1",
	"./code-outline.svg": "0664",
	"./code-sharp.svg": "1e3d",
	"./code-slash-outline.svg": "181b",
	"./code-slash-sharp.svg": "e647",
	"./code-slash.svg": "afe2",
	"./code-working-outline.svg": "39dd",
	"./code-working-sharp.svg": "83f8",
	"./code-working.svg": "b525",
	"./code.svg": "d7a5",
	"./cog-outline.svg": "839d",
	"./cog-sharp.svg": "60b7",
	"./cog.svg": "ba84",
	"./color-fill-outline.svg": "42cb",
	"./color-fill-sharp.svg": "e01f",
	"./color-fill.svg": "d641",
	"./color-filter-outline.svg": "19bb",
	"./color-filter-sharp.svg": "0173",
	"./color-filter.svg": "b37f",
	"./color-palette-outline.svg": "b7aa",
	"./color-palette-sharp.svg": "3ddf",
	"./color-palette.svg": "f83d",
	"./color-wand-outline.svg": "b2f2",
	"./color-wand-sharp.svg": "6159",
	"./color-wand.svg": "6f57",
	"./compass-outline.svg": "059d",
	"./compass-sharp.svg": "28af",
	"./compass.svg": "e67f",
	"./completed.svg": "2e64",
	"./construct-outline.svg": "11e8",
	"./construct-sharp.svg": "ed49",
	"./construct.svg": "29f8",
	"./contract-outline.svg": "cc09",
	"./contract-sharp.svg": "1a97",
	"./contract.svg": "eeeb",
	"./contrast-outline.svg": "99f5",
	"./contrast-sharp.svg": "a9d0",
	"./contrast.svg": "b152",
	"./copy-me.svg": "7b20",
	"./copy-outline.svg": "f8c5",
	"./copy-sharp.svg": "f4fb",
	"./copy.svg": "19b6b",
	"./create-outline.svg": "be94",
	"./create-sharp.svg": "0414",
	"./create.svg": "08d2",
	"./crop-outline.svg": "b4e3",
	"./crop-sharp.svg": "ba87",
	"./crop.svg": "11fe",
	"./cube-outline.svg": "fbb0",
	"./cube-sharp.svg": "4dfc",
	"./cube.svg": "16d2",
	"./cut-outline.svg": "4ffb",
	"./cut-sharp.svg": "3f7b",
	"./cut.svg": "e2c9",
	"./desktop-outline.svg": "d8eb",
	"./desktop-sharp.svg": "aa27",
	"./desktop.svg": "b52c",
	"./diamond-outline.svg": "e7ad",
	"./diamond-sharp.svg": "1b78",
	"./diamond.svg": "7753",
	"./dice-outline.svg": "e366",
	"./dice-sharp.svg": "a950",
	"./dice.svg": "4b33",
	"./disc-outline.svg": "8525",
	"./disc-sharp.svg": "7bb5",
	"./disc.svg": "c141",
	"./document-attach-outline.svg": "b177",
	"./document-attach-sharp.svg": "85c3",
	"./document-attach.svg": "10d8",
	"./document-lock-outline.svg": "2969",
	"./document-lock-sharp.svg": "4efa",
	"./document-lock.svg": "27c7",
	"./document-outline.svg": "6e8b",
	"./document-sharp.svg": "d3c6",
	"./document-text-outline.svg": "45d4",
	"./document-text-sharp.svg": "59a2",
	"./document-text.svg": "5192",
	"./document.svg": "fd28",
	"./documents-outline.svg": "c1de",
	"./documents-sharp.svg": "29a0",
	"./documents.svg": "5c07",
	"./download-outline.svg": "7528",
	"./download-sharp.svg": "e78c",
	"./download.svg": "4dae",
	"./duplicate-outline.svg": "6146",
	"./duplicate-sharp.svg": "258d",
	"./duplicate.svg": "ca07",
	"./ear-outline.svg": "a778",
	"./ear-sharp.svg": "7223",
	"./ear.svg": "72cc",
	"./earth-outline.svg": "1cf4",
	"./earth-sharp.svg": "cac1",
	"./earth.svg": "b2f0",
	"./easel-outline.svg": "3dc5",
	"./easel-sharp.svg": "7c48",
	"./easel.svg": "45a3",
	"./egg-outline.svg": "b7da",
	"./egg-sharp.svg": "8a76b",
	"./egg.svg": "abd6",
	"./ellipse-outline.svg": "27ac",
	"./ellipse-sharp.svg": "3d14",
	"./ellipse.svg": "89a7",
	"./ellipsis-horizontal-circle-outline.svg": "9b4c",
	"./ellipsis-horizontal-circle-sharp.svg": "eca2",
	"./ellipsis-horizontal-circle.svg": "4ab6",
	"./ellipsis-horizontal-outline.svg": "0983",
	"./ellipsis-horizontal-sharp.svg": "0509",
	"./ellipsis-horizontal.svg": "41a01",
	"./ellipsis-vertical-circle-outline.svg": "1e13",
	"./ellipsis-vertical-circle-sharp.svg": "50e7",
	"./ellipsis-vertical-circle.svg": "e263",
	"./ellipsis-vertical-outline.svg": "07f2",
	"./ellipsis-vertical-sharp.svg": "a917",
	"./ellipsis-vertical.svg": "aeef",
	"./enter-outline.svg": "1705",
	"./enter-sharp.svg": "aa4e",
	"./enter.svg": "2c41",
	"./exchange-board.svg": "1db0",
	"./exit-outline.svg": "1c6c",
	"./exit-sharp.svg": "f7a1",
	"./exit.svg": "5dbb",
	"./expand-outline.svg": "6e7d",
	"./expand-sharp.svg": "5d7f",
	"./expand.svg": "c963",
	"./extension-puzzle-outline.svg": "4742",
	"./extension-puzzle-sharp.svg": "f37c",
	"./extension-puzzle.svg": "f58b",
	"./eye-off-outline.svg": "4dec",
	"./eye-off-sharp.svg": "9be0",
	"./eye-off.svg": "bf89",
	"./eye-outline.svg": "f231",
	"./eye-sharp.svg": "27e2",
	"./eye.svg": "4df5",
	"./eyedrop-outline.svg": "c4af",
	"./eyedrop-sharp.svg": "160a",
	"./eyedrop.svg": "a716",
	"./fast-food-outline.svg": "f7b3",
	"./fast-food-sharp.svg": "982b",
	"./fast-food.svg": "f469",
	"./female-outline.svg": "203e",
	"./female-sharp.svg": "8e0f",
	"./female.svg": "b91d",
	"./file-tray-full-outline.svg": "dd89",
	"./file-tray-full-sharp.svg": "b21b",
	"./file-tray-full.svg": "a00f",
	"./file-tray-outline.svg": "7079",
	"./file-tray-sharp.svg": "0cf3",
	"./file-tray-stacked-outline.svg": "664f",
	"./file-tray-stacked-sharp.svg": "f42e",
	"./file-tray-stacked.svg": "44b6",
	"./file-tray.svg": "fea6",
	"./film-outline.svg": "d4e4",
	"./film-sharp.svg": "b300",
	"./film.svg": "ec95",
	"./filter-circle-outline.svg": "c861",
	"./filter-circle-sharp.svg": "05c2",
	"./filter-circle.svg": "453c",
	"./filter-outline.svg": "4f7e",
	"./filter-sharp.svg": "4dd8",
	"./filter.svg": "c886",
	"./finger-print-outline.svg": "7eed",
	"./finger-print-sharp.svg": "6a38",
	"./finger-print.svg": "f340",
	"./fish-outline.svg": "aea7",
	"./fish-sharp.svg": "271b",
	"./fish.svg": "4eb1",
	"./fitness-outline.svg": "49b2",
	"./fitness-sharp.svg": "a051",
	"./fitness.svg": "d92e",
	"./flag-outline.svg": "3f6f",
	"./flag-sharp.svg": "cf04",
	"./flag.svg": "be7f",
	"./flame-outline.svg": "3a17",
	"./flame-sharp.svg": "e98c",
	"./flame.svg": "c73e",
	"./flash-off-outline.svg": "1bd3",
	"./flash-off-sharp.svg": "f5a4",
	"./flash-off.svg": "6a26",
	"./flash-outline.svg": "e194",
	"./flash-sharp.svg": "62f5",
	"./flash.svg": "4ec3",
	"./flashlight-outline.svg": "4185",
	"./flashlight-sharp.svg": "0e64",
	"./flashlight.svg": "0a0c",
	"./flask-outline.svg": "570c",
	"./flask-sharp.svg": "3d4b",
	"./flask.svg": "5155",
	"./flower-outline.svg": "38fb",
	"./flower-sharp.svg": "9a8a",
	"./flower.svg": "2c4a",
	"./folder-open-outline.svg": "6f1c",
	"./folder-open-sharp.svg": "92d8",
	"./folder-open.svg": "6f95",
	"./folder-outline.svg": "c6d9",
	"./folder-sharp.svg": "7bbb",
	"./folder.svg": "d079",
	"./football-outline.svg": "22d4",
	"./football-sharp.svg": "30e3",
	"./football.svg": "1376",
	"./footsteps-outline.svg": "0734",
	"./footsteps-sharp.svg": "18f2",
	"./footsteps.svg": "ca67",
	"./funnel-outline.svg": "d07c",
	"./funnel-sharp.svg": "9fbe",
	"./funnel.svg": "2a30",
	"./game-controller-outline.svg": "9be7",
	"./game-controller-sharp.svg": "ef4e",
	"./game-controller.svg": "a650",
	"./gift-outline.svg": "837a",
	"./gift-sharp.svg": "52ec",
	"./gift.svg": "3d7b",
	"./git-branch-outline.svg": "09a6",
	"./git-branch-sharp.svg": "334e",
	"./git-branch.svg": "8a79",
	"./git-commit-outline.svg": "eef0",
	"./git-commit-sharp.svg": "fc8b",
	"./git-commit.svg": "d47c",
	"./git-compare-outline.svg": "1245",
	"./git-compare-sharp.svg": "d644",
	"./git-compare.svg": "bdda",
	"./git-merge-outline.svg": "04bf",
	"./git-merge-sharp.svg": "ae11",
	"./git-merge.svg": "f28d",
	"./git-network-outline.svg": "8497",
	"./git-network-sharp.svg": "5994",
	"./git-network.svg": "47dc",
	"./git-pull-request-outline.svg": "d573",
	"./git-pull-request-sharp.svg": "f4e1",
	"./git-pull-request.svg": "25d9",
	"./glasses-outline.svg": "659e",
	"./glasses-sharp.svg": "201e",
	"./glasses.svg": "dc6a",
	"./globe-outline.svg": "a319",
	"./globe-sharp.svg": "9e97",
	"./globe.svg": "3e66",
	"./golf-outline.svg": "ac54",
	"./golf-sharp.svg": "bc50",
	"./golf.svg": "8283",
	"./grid-outline.svg": "bdf5",
	"./grid-sharp.svg": "23c5",
	"./grid.svg": "d8ec",
	"./group-mgt.svg": "0aa95",
	"./hammer-outline.svg": "239b",
	"./hammer-sharp.svg": "cdf1",
	"./hammer.svg": "3f39",
	"./hand-left-outline.svg": "95f2",
	"./hand-left-sharp.svg": "6ebb",
	"./hand-left.svg": "a2b2",
	"./hand-right-outline.svg": "5611",
	"./hand-right-sharp.svg": "218f",
	"./hand-right.svg": "1e79",
	"./happy-outline.svg": "010a7",
	"./happy-sharp.svg": "fc4f",
	"./happy.svg": "7342",
	"./hardware-chip-outline.svg": "65ab",
	"./hardware-chip-sharp.svg": "1391",
	"./hardware-chip.svg": "20b5",
	"./headset-outline.svg": "37c2",
	"./headset-sharp.svg": "9ad9",
	"./headset.svg": "568c",
	"./heart-circle-outline.svg": "1784",
	"./heart-circle-sharp.svg": "3461",
	"./heart-circle.svg": "c8e6",
	"./heart-dislike-circle-outline.svg": "9b17",
	"./heart-dislike-circle-sharp.svg": "8381",
	"./heart-dislike-circle.svg": "99da",
	"./heart-dislike-outline.svg": "5910",
	"./heart-dislike-sharp.svg": "00de",
	"./heart-dislike.svg": "bc5b",
	"./heart-half-outline.svg": "dd29",
	"./heart-half-sharp.svg": "2483",
	"./heart-half.svg": "f18f",
	"./heart-outline.svg": "9caa",
	"./heart-sharp.svg": "6e6b",
	"./heart.svg": "c40a",
	"./help-buoy-outline.svg": "896d",
	"./help-buoy-sharp.svg": "a847",
	"./help-buoy.svg": "86d4",
	"./help-circle-outline.svg": "2ca8",
	"./help-circle-sharp.svg": "f1d9",
	"./help-circle.svg": "01a9",
	"./help-outline.svg": "8e11",
	"./help-sharp.svg": "5b39",
	"./help.svg": "c932",
	"./home-outline.svg": "c502",
	"./home-sharp.svg": "f766",
	"./home.svg": "6bbe",
	"./hourglass-outline.svg": "c8a1",
	"./hourglass-sharp.svg": "2e7b",
	"./hourglass.svg": "41f3",
	"./ice-cream-outline.svg": "51200",
	"./ice-cream-sharp.svg": "ec49",
	"./ice-cream.svg": "2f33",
	"./id-card-outline.svg": "9d66",
	"./id-card-sharp.svg": "94b2",
	"./id-card.svg": "d79b",
	"./image-outline.svg": "0cbc",
	"./image-sharp.svg": "55e2",
	"./image.svg": "8736",
	"./images-outline.svg": "c74e0",
	"./images-sharp.svg": "ecc5",
	"./images.svg": "b0cb",
	"./infinite-outline.svg": "2d4a",
	"./infinite-sharp.svg": "952d",
	"./infinite.svg": "390a",
	"./information-circle-outline.svg": "b0cc",
	"./information-circle-sharp.svg": "406c",
	"./information-circle.svg": "5491",
	"./information-outline.svg": "4c60",
	"./information-sharp.svg": "5588",
	"./information.svg": "035f",
	"./initiate.svg": "f5a7",
	"./invert-mode-outline.svg": "4fbe",
	"./invert-mode-sharp.svg": "0af0",
	"./invert-mode.svg": "5725",
	"./journal-outline.svg": "093a",
	"./journal-sharp.svg": "861d",
	"./journal.svg": "04c0",
	"./key-outline.svg": "6fc2",
	"./key-sharp.svg": "f9a9",
	"./key.svg": "e7b0",
	"./keypad-outline.svg": "4729",
	"./keypad-sharp.svg": "4f40",
	"./keypad.svg": "c8c4",
	"./language-outline.svg": "b673",
	"./language-sharp.svg": "b651",
	"./language.svg": "2580",
	"./laptop-outline.svg": "b865",
	"./laptop-sharp.svg": "41b9",
	"./laptop.svg": "8bbb",
	"./layers-outline.svg": "6d06",
	"./layers-sharp.svg": "cdd7",
	"./layers.svg": "0da3",
	"./leaf-outline.svg": "ddc7",
	"./leaf-sharp.svg": "ca7c",
	"./leaf.svg": "7820",
	"./library-outline.svg": "f4b4",
	"./library-sharp.svg": "64f3",
	"./library.svg": "90a0",
	"./link-outline.svg": "172d",
	"./link-sharp.svg": "60bd",
	"./link.svg": "18f0",
	"./list-circle-outline.svg": "b46a",
	"./list-circle-sharp.svg": "7e0a",
	"./list-circle.svg": "4f86",
	"./list-outline.svg": "5888",
	"./list-sharp.svg": "ba6b",
	"./list.svg": "3289",
	"./listSymbol.svg": "c7d2",
	"./locate-outline.svg": "ec26",
	"./locate-sharp.svg": "f2fc",
	"./locate.svg": "538f",
	"./location-outline.svg": "5bd5",
	"./location-sharp.svg": "6efd",
	"./location.svg": "1c50",
	"./lock-closed-outline.svg": "e62f",
	"./lock-closed-sharp.svg": "fcf7",
	"./lock-closed.svg": "935e",
	"./lock-open-outline.svg": "5069",
	"./lock-open-sharp.svg": "0ae5",
	"./lock-open.svg": "d226",
	"./log-in-outline.svg": "d584",
	"./log-in-sharp.svg": "8fb6",
	"./log-in.svg": "0339",
	"./log-out-outline.svg": "cbc5",
	"./log-out-sharp.svg": "ecb5",
	"./log-out.svg": "30fb",
	"./logo-alipay.svg": "3e0c",
	"./logo-amazon.svg": "886f",
	"./logo-amplify.svg": "2005",
	"./logo-android.svg": "2426",
	"./logo-angular.svg": "48df",
	"./logo-apple-appstore.svg": "657c",
	"./logo-apple-ar.svg": "5c38",
	"./logo-apple.svg": "a6db",
	"./logo-behance.svg": "5b94",
	"./logo-bitbucket.svg": "cdcb",
	"./logo-bitcoin.svg": "2432",
	"./logo-buffer.svg": "99ff",
	"./logo-capacitor.svg": "7ab0",
	"./logo-chrome.svg": "8261",
	"./logo-closed-captioning.svg": "fd5c",
	"./logo-codepen.svg": "8a2e",
	"./logo-css3.svg": "44bd",
	"./logo-designernews.svg": "7751",
	"./logo-deviantart.svg": "7a62",
	"./logo-discord.svg": "2f38",
	"./logo-docker.svg": "107d",
	"./logo-dribbble.svg": "b784",
	"./logo-dropbox.svg": "28c3",
	"./logo-edge.svg": "6b26",
	"./logo-electron.svg": "8acb",
	"./logo-euro.svg": "5030",
	"./logo-facebook.svg": "c897",
	"./logo-figma.svg": "de82",
	"./logo-firebase.svg": "fa8e",
	"./logo-firefox.svg": "704b",
	"./logo-flickr.svg": "513a",
	"./logo-foursquare.svg": "6bdb",
	"./logo-github.svg": "98df",
	"./logo-gitlab.svg": "4e5c",
	"./logo-google-playstore.svg": "1d55",
	"./logo-google.svg": "3b4c",
	"./logo-hackernews.svg": "da98",
	"./logo-html5.svg": "2678",
	"./logo-instagram.svg": "a5dd",
	"./logo-ionic.svg": "5861",
	"./logo-ionitron.svg": "3d8e",
	"./logo-javascript.svg": "22b3",
	"./logo-laravel.svg": "ea72",
	"./logo-linkedin.svg": "bc86",
	"./logo-markdown.svg": "cef4",
	"./logo-mastodon.svg": "c057",
	"./logo-medium.svg": "7d71",
	"./logo-microsoft.svg": "e36d",
	"./logo-no-smoking.svg": "e6e8",
	"./logo-nodejs.svg": "5dc7",
	"./logo-npm.svg": "f8be",
	"./logo-octocat.svg": "5a75",
	"./logo-paypal.svg": "0bbd",
	"./logo-pinterest.svg": "a35d",
	"./logo-playstation.svg": "8db0",
	"./logo-pwa.svg": "30a3",
	"./logo-python.svg": "d78d",
	"./logo-react.svg": "fa62",
	"./logo-reddit.svg": "4b6a",
	"./logo-rss.svg": "1732",
	"./logo-sass.svg": "f7de",
	"./logo-skype.svg": "0d4e",
	"./logo-slack.svg": "f0cd",
	"./logo-snapchat.svg": "a95a",
	"./logo-soundcloud.svg": "83a0",
	"./logo-stackoverflow.svg": "4069",
	"./logo-steam.svg": "c900",
	"./logo-stencil.svg": "54e3",
	"./logo-tableau.svg": "6793",
	"./logo-tiktok.svg": "c9d6",
	"./logo-tumblr.svg": "8d2a",
	"./logo-tux.svg": "033d",
	"./logo-twitch.svg": "7eca",
	"./logo-twitter.svg": "0124",
	"./logo-usd.svg": "702d",
	"./logo-venmo.svg": "0fc5",
	"./logo-vercel.svg": "1350",
	"./logo-vimeo.svg": "14dc",
	"./logo-vk.svg": "1ee6",
	"./logo-vue.svg": "f9f3",
	"./logo-web-component.svg": "7219",
	"./logo-wechat.svg": "cdee",
	"./logo-whatsapp.svg": "cc95",
	"./logo-windows.svg": "3238",
	"./logo-wordpress.svg": "db8f",
	"./logo-xbox.svg": "4920",
	"./logo-xing.svg": "a223",
	"./logo-yahoo.svg": "dbe7",
	"./logo-yen.svg": "a995",
	"./logo-youtube.svg": "adaf",
	"./magnet-outline.svg": "e73f",
	"./magnet-sharp.svg": "82b4",
	"./magnet.svg": "f074",
	"./mail-open-outline.svg": "fea9",
	"./mail-open-sharp.svg": "02d4",
	"./mail-open.svg": "d25e",
	"./mail-outline.svg": "7664",
	"./mail-sharp.svg": "5271",
	"./mail-unread-outline.svg": "c61e",
	"./mail-unread-sharp.svg": "21d4",
	"./mail-unread.svg": "2547",
	"./mail.svg": "26f5",
	"./male-female-outline.svg": "9851",
	"./male-female-sharp.svg": "e245",
	"./male-female.svg": "de83",
	"./male-outline.svg": "a2e6",
	"./male-sharp.svg": "c4bf",
	"./male.svg": "d6de",
	"./man-outline.svg": "df7b",
	"./man-sharp.svg": "8bc1",
	"./man.svg": "8b7b",
	"./map-outline.svg": "a6c6",
	"./map-sharp.svg": "4dff",
	"./map.svg": "a13f",
	"./medal-outline.svg": "5c10",
	"./medal-sharp.svg": "520f",
	"./medal.svg": "428d",
	"./medical-outline.svg": "e15a",
	"./medical-sharp.svg": "a5d2",
	"./medical.svg": "d3a9",
	"./medkit-outline.svg": "333c",
	"./medkit-sharp.svg": "98c3",
	"./medkit.svg": "bd3e",
	"./megaphone-outline.svg": "86d7",
	"./megaphone-sharp.svg": "7362",
	"./megaphone.svg": "5e33",
	"./menu-outline.svg": "456f",
	"./menu-sharp.svg": "d82f",
	"./menu.svg": "bd3d",
	"./mic-circle-outline.svg": "4f56",
	"./mic-circle-sharp.svg": "ddbf",
	"./mic-circle.svg": "d6ae",
	"./mic-off-circle-outline.svg": "a6af",
	"./mic-off-circle-sharp.svg": "857b",
	"./mic-off-circle.svg": "2980",
	"./mic-off-outline.svg": "cf7c",
	"./mic-off-sharp.svg": "08db",
	"./mic-off.svg": "2aae",
	"./mic-outline.svg": "6744",
	"./mic-sharp.svg": "6853",
	"./mic.svg": "099b",
	"./moon-outline.svg": "2271",
	"./moon-sharp.svg": "325b",
	"./moon.svg": "be6e",
	"./move-outline.svg": "9bfeb",
	"./move-sharp.svg": "9a79",
	"./move.svg": "2df4",
	"./musical-note-outline.svg": "0de4",
	"./musical-note-sharp.svg": "1bee",
	"./musical-note.svg": "d0f1",
	"./musical-notes-outline.svg": "a7a1",
	"./musical-notes-sharp.svg": "51ed",
	"./musical-notes.svg": "e0f9",
	"./navigate-circle-outline.svg": "00c3",
	"./navigate-circle-sharp.svg": "4852",
	"./navigate-circle.svg": "c9fa",
	"./navigate-outline.svg": "d074",
	"./navigate-sharp.svg": "6905",
	"./navigate.svg": "a188",
	"./newspaper-outline.svg": "a066",
	"./newspaper-sharp.svg": "7b81",
	"./newspaper.svg": "96a4",
	"./notifications-circle-outline.svg": "c7f4",
	"./notifications-circle-sharp.svg": "fc06",
	"./notifications-circle.svg": "d782",
	"./notifications-off-circle-outline.svg": "b325",
	"./notifications-off-circle-sharp.svg": "5f3d",
	"./notifications-off-circle.svg": "851e",
	"./notifications-off-outline.svg": "bfe8",
	"./notifications-off-sharp.svg": "2bc6",
	"./notifications-off.svg": "9ab9",
	"./notifications-outline.svg": "e0b0",
	"./notifications-sharp.svg": "73f8",
	"./notifications.svg": "08aa",
	"./nuclear-outline.svg": "9e31",
	"./nuclear-sharp.svg": "46c1",
	"./nuclear.svg": "7ce8",
	"./nutrition-outline.svg": "bf70",
	"./nutrition-sharp.svg": "85ed",
	"./nutrition.svg": "7aa5",
	"./open-outline.svg": "a6e0",
	"./open-sharp.svg": "2524",
	"./open.svg": "ace4",
	"./options-outline.svg": "c504",
	"./options-sharp.svg": "cd39",
	"./options.svg": "f09e",
	"./pallet.svg": "4e05",
	"./paper-plane-outline.svg": "6874",
	"./paper-plane-sharp.svg": "2d9c",
	"./paper-plane.svg": "3164",
	"./partly-sunny-outline.svg": "bb07",
	"./partly-sunny-sharp.svg": "7144",
	"./partly-sunny.svg": "eefa",
	"./pause-circle-outline.svg": "5c05",
	"./pause-circle-sharp.svg": "f35c",
	"./pause-circle.svg": "044d",
	"./pause-outline.svg": "16b1",
	"./pause-sharp.svg": "781f",
	"./pause.svg": "d46e",
	"./paw-outline.svg": "bdc3",
	"./paw-sharp.svg": "3e35",
	"./paw.svg": "b89e",
	"./pencil-outline.svg": "f3ef",
	"./pencil-sharp.svg": "edb2",
	"./pencil.svg": "05c4",
	"./people-circle-outline.svg": "c217",
	"./people-circle-sharp.svg": "2881",
	"./people-circle.svg": "9a7c",
	"./people-outline.svg": "d75c",
	"./people-sharp.svg": "5f45",
	"./people.svg": "d056",
	"./person-add-outline.svg": "69cc",
	"./person-add-sharp.svg": "9f54",
	"./person-add.svg": "9751",
	"./person-circle-outline.svg": "2d7c",
	"./person-circle-sharp.svg": "3125",
	"./person-circle.svg": "8796",
	"./person-outline.svg": "07a8",
	"./person-remove-outline.svg": "2e13",
	"./person-remove-sharp.svg": "4c8c",
	"./person-remove.svg": "86d6",
	"./person-sharp.svg": "0a04",
	"./person.svg": "a450",
	"./phone-landscape-outline.svg": "b2e6",
	"./phone-landscape-sharp.svg": "c2ff",
	"./phone-landscape.svg": "90ad",
	"./phone-portrait-outline.svg": "0a4e",
	"./phone-portrait-sharp.svg": "d465",
	"./phone-portrait.svg": "6fab",
	"./pie-chart-outline.svg": "1117",
	"./pie-chart-sharp.svg": "df0c",
	"./pie-chart.svg": "463d",
	"./pin-outline.svg": "787d",
	"./pin-sharp.svg": "f6bc",
	"./pin.svg": "2dc0",
	"./pint-outline.svg": "9a27",
	"./pint-sharp.svg": "abe7",
	"./pint.svg": "d8e6",
	"./pizza-outline.svg": "ec06",
	"./pizza-sharp.svg": "e425",
	"./pizza.svg": "0402",
	"./planet-outline.svg": "9dd1",
	"./planet-sharp.svg": "9eb8",
	"./planet.svg": "43be",
	"./play-back-circle-outline.svg": "1a58",
	"./play-back-circle-sharp.svg": "dd6d",
	"./play-back-circle.svg": "7db22",
	"./play-back-outline.svg": "1abb",
	"./play-back-sharp.svg": "5a73",
	"./play-back.svg": "288d",
	"./play-circle-outline.svg": "9026",
	"./play-circle-sharp.svg": "e19d",
	"./play-circle.svg": "35c7",
	"./play-forward-circle-outline.svg": "3df0",
	"./play-forward-circle-sharp.svg": "1370",
	"./play-forward-circle.svg": "0616",
	"./play-forward-outline.svg": "721f",
	"./play-forward-sharp.svg": "cb2a",
	"./play-forward.svg": "f3f8",
	"./play-outline.svg": "b123",
	"./play-sharp.svg": "b38f",
	"./play-skip-back-circle-outline.svg": "c05b",
	"./play-skip-back-circle-sharp.svg": "5133",
	"./play-skip-back-circle.svg": "e835",
	"./play-skip-back-outline.svg": "c54c",
	"./play-skip-back-sharp.svg": "9d69",
	"./play-skip-back.svg": "3083",
	"./play-skip-forward-circle-outline.svg": "96c3",
	"./play-skip-forward-circle-sharp.svg": "f5be",
	"./play-skip-forward-circle.svg": "8df2",
	"./play-skip-forward-outline.svg": "1812",
	"./play-skip-forward-sharp.svg": "130f",
	"./play-skip-forward.svg": "e4d5",
	"./play.svg": "fb4f",
	"./plc.svg": "9556",
	"./podium-outline.svg": "da53",
	"./podium-sharp.svg": "4a25",
	"./podium.svg": "03c0",
	"./power-outline.svg": "1939",
	"./power-sharp.svg": "b24b",
	"./power.svg": "0e5c",
	"./pricetag-outline.svg": "8b70",
	"./pricetag-sharp.svg": "10a1",
	"./pricetag.svg": "aebd",
	"./pricetags-outline.svg": "b88d",
	"./pricetags-sharp.svg": "2a88",
	"./pricetags.svg": "4aa6",
	"./print-outline.svg": "fdc8",
	"./print-sharp.svg": "d257",
	"./print.svg": "04d5",
	"./prism-outline.svg": "3031",
	"./prism-sharp.svg": "8657",
	"./prism.svg": "5a2d",
	"./process-design.svg": "f663",
	"./process-fill.svg": "8a3f",
	"./process-template.svg": "fbb7",
	"./pulse-outline.svg": "377f",
	"./pulse-sharp.svg": "da32",
	"./pulse.svg": "74cb",
	"./push-outline.svg": "f0ce",
	"./push-sharp.svg": "d016",
	"./push.svg": "dc9d",
	"./qr-code-outline.svg": "b6fb",
	"./qr-code-sharp.svg": "d89b",
	"./qr-code.svg": "2ae8",
	"./radio-button-off-outline.svg": "1c5e",
	"./radio-button-off-sharp.svg": "09eb",
	"./radio-button-off.svg": "6ef4",
	"./radio-button-on-outline.svg": "89ef",
	"./radio-button-on-sharp.svg": "279a",
	"./radio-button-on.svg": "6518",
	"./radio-outline.svg": "9db4",
	"./radio-sharp.svg": "08f7",
	"./radio.svg": "d8dc",
	"./rainy-outline.svg": "84df",
	"./rainy-sharp.svg": "3cbd",
	"./rainy.svg": "1931",
	"./rate-of-progress.svg": "f1f3",
	"./reader-outline.svg": "0731",
	"./reader-sharp.svg": "b31f",
	"./reader.svg": "31dd",
	"./receipt-outline.svg": "e62c4",
	"./receipt-sharp.svg": "eba1",
	"./receipt.svg": "2824",
	"./recording-outline.svg": "bed2",
	"./recording-sharp.svg": "838b",
	"./recording.svg": "f683",
	"./refresh-circle-outline.svg": "edf3",
	"./refresh-circle-sharp.svg": "918b",
	"./refresh-circle.svg": "825d",
	"./refresh-outline.svg": "614b",
	"./refresh-sharp.svg": "cc73",
	"./refresh.svg": "b8c4",
	"./reload-circle-outline.svg": "98ff",
	"./reload-circle-sharp.svg": "a2b0",
	"./reload-circle.svg": "355a",
	"./reload-outline.svg": "c6b6",
	"./reload-sharp.svg": "6d43",
	"./reload.svg": "217a",
	"./remove-circle-outline.svg": "18e5",
	"./remove-circle-sharp.svg": "5f0c",
	"./remove-circle.svg": "eb48",
	"./remove-outline.svg": "b30c",
	"./remove-sharp.svg": "8640",
	"./remove.svg": "861a",
	"./reorder-four-outline.svg": "3a59",
	"./reorder-four-sharp.svg": "1ea4",
	"./reorder-four.svg": "ebab",
	"./reorder-three-outline.svg": "fe91",
	"./reorder-three-sharp.svg": "1491",
	"./reorder-three.svg": "6daa",
	"./reorder-two-outline.svg": "d01a",
	"./reorder-two-sharp.svg": "4d59",
	"./reorder-two.svg": "b9a1",
	"./repeat-outline.svg": "9762",
	"./repeat-sharp.svg": "52d5",
	"./repeat.svg": "e04c",
	"./resize-outline.svg": "01dd",
	"./resize-sharp.svg": "497e",
	"./resize.svg": "e833",
	"./restaurant-outline.svg": "aba6",
	"./restaurant-sharp.svg": "2d34",
	"./restaurant.svg": "95cb",
	"./return-down-back-outline.svg": "4d48",
	"./return-down-back-sharp.svg": "ac94",
	"./return-down-back.svg": "d840",
	"./return-down-forward-outline.svg": "d544",
	"./return-down-forward-sharp.svg": "69fd",
	"./return-down-forward.svg": "6d8f",
	"./return-up-back-outline.svg": "d796",
	"./return-up-back-sharp.svg": "e545",
	"./return-up-back.svg": "1a52",
	"./return-up-forward-outline.svg": "6145",
	"./return-up-forward-sharp.svg": "7e68",
	"./return-up-forward.svg": "f2c5",
	"./ribbon-outline.svg": "5b75",
	"./ribbon-sharp.svg": "4f2b",
	"./ribbon.svg": "509e",
	"./rocket-outline.svg": "a0ab",
	"./rocket-sharp.svg": "f752",
	"./rocket.svg": "59ac",
	"./rose-outline.svg": "11f3",
	"./rose-sharp.svg": "f2c2",
	"./rose.svg": "b192",
	"./sad-outline.svg": "3202",
	"./sad-sharp.svg": "031b",
	"./sad.svg": "9408",
	"./save-outline.svg": "b02e",
	"./save-sharp.svg": "5e66",
	"./save.svg": "0e55",
	"./scale-outline.svg": "2fe5",
	"./scale-sharp.svg": "c3c6",
	"./scale.svg": "3acd",
	"./scan-circle-outline.svg": "dbe71",
	"./scan-circle-sharp.svg": "3cea",
	"./scan-circle.svg": "4d72",
	"./scan-outline.svg": "300a",
	"./scan-sharp.svg": "1d72",
	"./scan.svg": "9a02",
	"./school-outline.svg": "afde",
	"./school-sharp.svg": "3d8d",
	"./school.svg": "c033",
	"./search-circle-outline.svg": "d237",
	"./search-circle-sharp.svg": "4b05",
	"./search-circle.svg": "f167",
	"./search-outline.svg": "137e",
	"./search-sharp.svg": "81aa",
	"./search.svg": "8e8d",
	"./send-outline.svg": "314f",
	"./send-sharp.svg": "79ae",
	"./send.svg": "94d0",
	"./server-outline.svg": "dfde",
	"./server-sharp.svg": "0e90",
	"./server.svg": "cda5",
	"./servers.svg": "32c1",
	"./settings-outline.svg": "a73f",
	"./settings-sharp.svg": "88e1",
	"./settings.svg": "3fc8",
	"./shapes-outline.svg": "dc92",
	"./shapes-sharp.svg": "63e5",
	"./shapes.svg": "ecb7",
	"./share-outline.svg": "8b68",
	"./share-sharp.svg": "5ab3",
	"./share-social-outline.svg": "d333",
	"./share-social-sharp.svg": "7ae7",
	"./share-social.svg": "a23b",
	"./share.svg": "5306",
	"./shield-checkmark-outline.svg": "b21f",
	"./shield-checkmark-sharp.svg": "49f0",
	"./shield-checkmark.svg": "1196",
	"./shield-half-outline.svg": "0f82",
	"./shield-half-sharp.svg": "e1e0",
	"./shield-half.svg": "1acb",
	"./shield-outline.svg": "5810",
	"./shield-sharp.svg": "7c17",
	"./shield.svg": "979c",
	"./shirt-outline.svg": "0be7",
	"./shirt-sharp.svg": "9264",
	"./shirt.svg": "0685",
	"./shuffle-outline.svg": "0804",
	"./shuffle-sharp.svg": "20c0",
	"./shuffle.svg": "4a44",
	"./skull-outline.svg": "271f",
	"./skull-sharp.svg": "6b6d",
	"./skull.svg": "1950",
	"./snow-outline.svg": "2909",
	"./snow-sharp.svg": "2a6a",
	"./snow.svg": "ec55",
	"./sparkles-outline.svg": "bfab",
	"./sparkles-sharp.svg": "bc73",
	"./sparkles.svg": "7e5b",
	"./speedometer-outline.svg": "015b",
	"./speedometer-sharp.svg": "39eb",
	"./speedometer.svg": "1095",
	"./square-outline.svg": "de9f",
	"./square-sharp.svg": "a398",
	"./square.svg": "b0c2",
	"./stamp.svg": "23a9",
	"./star-half-outline.svg": "fa24",
	"./star-half-sharp.svg": "70bfa",
	"./star-half.svg": "8480",
	"./star-outline.svg": "ce38",
	"./star-sharp.svg": "7e24",
	"./star.svg": "708a",
	"./stats-chart-outline.svg": "311a",
	"./stats-chart-sharp.svg": "ff18",
	"./stats-chart.svg": "3e4c",
	"./stop-circle-outline.svg": "432e",
	"./stop-circle-sharp.svg": "e386",
	"./stop-circle.svg": "9b73",
	"./stop-outline.svg": "2f61",
	"./stop-sharp.svg": "aefe",
	"./stop.svg": "bdb7",
	"./stopwatch-outline.svg": "3269",
	"./stopwatch-sharp.svg": "4f63",
	"./stopwatch.svg": "c071",
	"./storefront-outline.svg": "6931",
	"./storefront-sharp.svg": "4a08",
	"./storefront.svg": "d712",
	"./subway-outline.svg": "5703",
	"./subway-sharp.svg": "4177b",
	"./subway.svg": "9716",
	"./sunny-outline.svg": "bfa2",
	"./sunny-sharp.svg": "a6ba",
	"./sunny.svg": "9bc4",
	"./swap-horizontal-outline.svg": "5d3c",
	"./swap-horizontal-sharp.svg": "93ec",
	"./swap-horizontal.svg": "a6ab",
	"./swap-vertical-outline.svg": "3ea8",
	"./swap-vertical-sharp.svg": "bc02",
	"./swap-vertical.svg": "ea1c",
	"./sync-circle-outline.svg": "4e86",
	"./sync-circle-sharp.svg": "c2c8",
	"./sync-circle.svg": "e843",
	"./sync-outline.svg": "a9e8",
	"./sync-sharp.svg": "dfd2",
	"./sync.svg": "3e1b",
	"./tablet-landscape-outline.svg": "6a6a",
	"./tablet-landscape-sharp.svg": "afdd",
	"./tablet-landscape.svg": "b312",
	"./tablet-portrait-outline.svg": "64fe",
	"./tablet-portrait-sharp.svg": "09b1",
	"./tablet-portrait.svg": "ae9f",
	"./telescope-outline.svg": "5c1a",
	"./telescope-sharp.svg": "072d",
	"./telescope.svg": "d9fd",
	"./tennisball-outline.svg": "69b0",
	"./tennisball-sharp.svg": "f07e",
	"./tennisball.svg": "447a",
	"./terminal-outline.svg": "b83f",
	"./terminal-sharp.svg": "ff4e",
	"./terminal.svg": "0243",
	"./text-outline.svg": "e8c7",
	"./text-sharp.svg": "54d0",
	"./text.svg": "c5f6",
	"./thermometer-outline.svg": "cb6f",
	"./thermometer-sharp.svg": "1853",
	"./thermometer.svg": "91c3",
	"./thumbs-down-outline.svg": "a736",
	"./thumbs-down-sharp.svg": "a3ff",
	"./thumbs-down.svg": "cab9",
	"./thumbs-up-outline.svg": "04dc",
	"./thumbs-up-sharp.svg": "fc45",
	"./thumbs-up.svg": "98e0",
	"./thunderstorm-outline.svg": "04e5",
	"./thunderstorm-sharp.svg": "0c43",
	"./thunderstorm.svg": "c20a",
	"./ticket-outline.svg": "98eb",
	"./ticket-sharp.svg": "d0ff",
	"./ticket.svg": "b38e",
	"./time-outline.svg": "2fe8",
	"./time-sharp.svg": "b6ec",
	"./time.svg": "3add",
	"./timer-outline.svg": "2f50",
	"./timer-sharp.svg": "fb57",
	"./timer.svg": "4e0b",
	"./to-do-list.svg": "0843",
	"./today-outline.svg": "a10d",
	"./today-sharp.svg": "4f3a",
	"./today.svg": "cd09",
	"./toggle-outline.svg": "0342",
	"./toggle-sharp.svg": "20d8",
	"./toggle.svg": "510c",
	"./trail-sign-outline.svg": "9066",
	"./trail-sign-sharp.svg": "b38f6",
	"./trail-sign.svg": "e91d",
	"./train-outline.svg": "476e",
	"./train-sharp.svg": "c18c",
	"./train.svg": "1f54",
	"./transgender-outline.svg": "bcd5",
	"./transgender-sharp.svg": "b32f",
	"./transgender.svg": "31b1",
	"./trash-bin-outline.svg": "c010",
	"./trash-bin-sharp.svg": "e34e",
	"./trash-bin.svg": "b884",
	"./trash-outline.svg": "b372",
	"./trash-sharp.svg": "fa74",
	"./trash.svg": "ce30",
	"./trending-down-outline.svg": "666c",
	"./trending-down-sharp.svg": "acf8",
	"./trending-down.svg": "1906",
	"./trending-up-outline.svg": "973c",
	"./trending-up-sharp.svg": "58ce",
	"./trending-up.svg": "d483",
	"./triangle-outline.svg": "6abe",
	"./triangle-sharp.svg": "ca69",
	"./triangle.svg": "f13f",
	"./trophy-outline.svg": "1682",
	"./trophy-sharp.svg": "f34f",
	"./trophy.svg": "617f",
	"./tv-outline.svg": "7368",
	"./tv-sharp.svg": "ca77",
	"./tv.svg": "1b784",
	"./umbrella-outline.svg": "8ff4",
	"./umbrella-sharp.svg": "f39c",
	"./umbrella.svg": "3f20",
	"./unlink-outline.svg": "9bb3",
	"./unlink-sharp.svg": "df00",
	"./unlink.svg": "2c73",
	"./videocam-off-outline.svg": "3bdd",
	"./videocam-off-sharp.svg": "7869",
	"./videocam-off.svg": "32cf",
	"./videocam-outline.svg": "52e4",
	"./videocam-sharp.svg": "e912",
	"./videocam.svg": "7d00",
	"./volume-high-outline.svg": "7559",
	"./volume-high-sharp.svg": "35d7",
	"./volume-high.svg": "d455",
	"./volume-low-outline.svg": "85f2",
	"./volume-low-sharp.svg": "cef8",
	"./volume-low.svg": "c6c5",
	"./volume-medium-outline.svg": "8fc8",
	"./volume-medium-sharp.svg": "336a",
	"./volume-medium.svg": "b255",
	"./volume-mute-outline.svg": "c6e9",
	"./volume-mute-sharp.svg": "ae4a",
	"./volume-mute.svg": "4fec",
	"./volume-off-outline.svg": "1316",
	"./volume-off-sharp.svg": "6826",
	"./volume-off.svg": "6a06",
	"./walk-outline.svg": "80fd",
	"./walk-sharp.svg": "f954",
	"./walk.svg": "a0c8",
	"./wallet-outline.svg": "db8a",
	"./wallet-sharp.svg": "869a",
	"./wallet.svg": "402b",
	"./warning-outline.svg": "6f6d",
	"./warning-sharp.svg": "3085",
	"./warning.svg": "7e6f",
	"./watch-outline.svg": "e069",
	"./watch-sharp.svg": "af56",
	"./watch.svg": "e66d",
	"./water-outline.svg": "5bec",
	"./water-sharp.svg": "a560",
	"./water.svg": "2edb",
	"./wifi-outline.svg": "de30",
	"./wifi-sharp.svg": "4787",
	"./wifi.svg": "72b5",
	"./wine-outline.svg": "dc01",
	"./wine-sharp.svg": "0c249",
	"./wine.svg": "2eeb",
	"./woman-outline.svg": "b0fa",
	"./woman-sharp.svg": "3d68",
	"./woman.svg": "0bc4",
	"./xml.svg": "8f57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";